<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
          <!-- //@change="onFilePicked_image_bar_code" -->
         <!--  <qr-code ref="qr_code" :text="message"  id="qr_code"></qr-code> -->
           <!--  -->
            <!-- <v-btn color="primary" @click="MemberSince" >MemberSince</v-btn> -->
         <!--   <v-btn color="primary" @click="download_images" >download_images</v-btn> -->
         <v-dialog
      v-model="dataLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
        <!-- mini statistic start -->
        <v-flex @click="allMembers" lg3 sm6 xs12>
          <mini-statistic
           
             style="cursor: pointer"
            icon="account_circle"
            :title="this.members.length"
            :sub-title="$t('dashboard._Total_')"
            color="indigo"      
          >
          </mini-statistic>  
        </v-flex>
         <v-flex @click="todayMembers" lg3 sm6 xs12>
          <mini-statistic
            
            style="cursor: pointer"
            icon="people"
            :title="this.todays.length"
            :sub-title="$t('dashboard._Today_')"
            color="red"      
          >
          </mini-statistic>           
        </v-flex>          
        <v-flex @click="showServiteurs" lg3 sm6 xs12>
          <mini-statistic
            
             style="cursor: pointer"
            icon="supervised_user_circle"
            :title="this.serviteurs.length"
             :sub-title="$t('dashboard._servants_')"
            color="green"      
          >
          </mini-statistic>            
        </v-flex>        
        <v-flex @click="showMassaga" lg3 sm6 xs12>
          <mini-statistic
            style="cursor: pointer"
            icon="fa fa-instagram"
            :title="this.massaga.length"
            :sub-title="$t('dashboard._massaga_')"
            color="purple"      
          >
          </mini-statistic>             
        </v-flex> 
        <!-- mini statistic  end -->   

        <v-flex >
          <v-widget title="Statistiques de données saisies" content-bg="white">

 <br><br><br><br><br><br>
 <div slot="widget-content" align="center">

  <v-btn v-if="show_btn" color="primary" @click="loadCharts" > <v-icon>refresh</v-icon></v-btn>
  <table cellspacing=”10″ cellpadding=”5″ border="1px"  v-if="loaded">
    <tr>
        <td style="margin: 10px; padding: 5px;"> <div class="divchart fixed"> <pie-example v-if="loaded" :datasets='datasets_Matrial'  :labels='labels_Matrial' :options='chartoptions'></pie-example></div> </td>
  <td style="margin: 10px; padding: 5px;">  <div class=" divchart flex-item"><pie-example v-if="loaded" :datasets='datasets_gender'  :labels='labels_gender' :options='chartoptions'></pie-example></div> </td>
  <td style="margin: 10px; padding: 5px;">  <div class="divchart fixed"><pie-example v-if="loaded" :datasets='datasets_child'  :labels='labels_child' :options='chartoptions'></pie-example></div></td>
    </tr>
    <tr>
         <td style="margin: 10px; padding: 5px;">      <div class="divchart fixed"><pie-example v-if="loaded" :datasets='datasets_role'  :labels='labels_role' :options='chartoptions'></pie-example></div> </td>
            <td style="margin: 10px; padding: 5px;">    <div class="divchart flex-item"> <pie-example v-if="loaded" :datasets='datasets_school'  :labels='labels_school' :options='chartoptions'></pie-example></div> </td>
          <td style="margin: 10px; padding: 5px;">     <div class="divchart fixed"><pie-example v-if="loaded" :datasets='datasets_smart'  :labels='labels_smart' :options='chartoptions'></pie-example></div> </td>
      </tr>
 </table>
 </div>
          </v-widget>  
        </v-flex>
      </v-layout>
    
   

    </v-container>
  </div>
</template>

<script>

/* eslint-disable */
import QRCode from '@/api/qrcode.min.js';
import API from '@/api';
import EChart from '@/components/chart/echart';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
// import PlainTable from '@/components/widgets/list/PlainTable';

import VWidget from '@/components/VWidget';
import Material from 'vuetify/es5/util/colors';
import VCircle from '@/components/circle/VCircle';
import BoxChart from '@/components/widgets/chart/BoxChart';
import ChatWindow from '@/components/chat/ChatWindow';
import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
import { db,storage } from '@/api/firebaseInit';
import firebase from 'firebase';
import LineExample from '@/components/chart/LineExample'
import PieExample from '@/components/chart/PieExample'


export default {

  components: {
    PieExample,
    LineExample,
    MiniStatistic,
    ChatWindow,
    VCircle,
    EChart,
    BoxChart,
    CircleStatistic,
    LinearStatistic,
    // PlainTable,
      
  },
  data: () => ({
         show_btn:true,
         loaded:false,
         labels_school:[],
         datasets_school: [], 
         labels_smart:[],
        datasets_smart: [], 
        labels_role:[],
        datasets_role: [], 
        labels_gender:[],
        datasets_gender: [], 
        labels_child:[],
        datasets_child: [], 
        labels_Matrial:[],
        datasets_Matrial: [], 
         //Chart.js options that controls the appearance of the chart
         chartoptions: {
            responsive: true,
            maintainAspectRatio: false
         },
    message :'x',
    color: Material,
    selectedTab: 'tab-1',
    valid: false,
    converts: [],
    qrCodes:[]  
  }),
  computed: {
 //change this back after finish
     dataLoading () {
       let loading = false
       if (this.users.length !=0) {
         loading = false
         
        this.loadCharts()
        
       }
    
      return loading;
    },

    members () {
      var members = this.$store.getters.members
     
      return members
    },
       users () {
      var users = this.$store.getters.users
      return users
    },
    todays () {
      var todays = this.$store.getters.todays
      return todays
    },
    serviteurs () {
      var serviteurs = this.$store.getters.serviteurs
      return serviteurs
    },
       massaga () {
      var massaga = this.$store.getters.massaga
      return massaga
    },
     employees () {
      var employees = this.$store.getters.employees
      return employees
    },
    activity () {
      return API.getActivity();
    },
    posts () {
      return API.getPost(3);
    },
    siteTrafficData () {
      return API.getMonthVisit;
    },
    locationData () {
      return API.getLocation;
    }
    

    
  },
   watch: {
    
        

    },
   created () {
      var today = (new Date()).toString();
             today = today.substring(0, 15);    

    },
    mounted() {
    /*    if(this.dataLoading()) {
         this.GroupByGender()
    this.GroupBymaterialStatus()
    this.GroupByChildren()
    this.GroupByRole()
    this.GroupBySchool_level()
    this.GroupBySmart()
      }*/
    },
  methods: {
loadCharts()
{
if(this.members.length !=0) {
    /*this.GroupByGender()
    this.GroupBymaterialStatus()
    this.GroupByChildren()
    this.GroupByRole()
    this.GroupBySchool_level()
    this.GroupBySmart() */
    this.loaded= true;
} else {
  //this.show_btn=true;
}
},
 groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
},

GroupByGender () {

//const grouped = this.groupBy(pets, pet => pet.type);
const grouped = this.groupBy(this.members, member => member.gender);
var M = grouped.get("M") != undefined ? grouped.get("M").length :0
var F = grouped.get("F") != undefined ? grouped.get("F").length :0
  this.labels_gender = ["Male", "Female"];
      this.datasets_gender= [
        {
          backgroundColor: [
            'rgba(65, 184, 131, .8)',
            'rgba(228, 102, 81, .8)'
          ],
          borderWidth: 0,
          data: [M, F]
        }
      ];

},

GroupBySchool_level () {

//const grouped = this.groupBy(pets, pet => pet.type);
const grouped = this.groupBy(this.members, member => member.niveauScolaire);

//console.log(grouped)
var NS = grouped.get("NS") != undefined ? grouped.get("NS").length :0
var ES = grouped.get("ES") != undefined ? grouped.get("ES").length :0
var SS = grouped.get("SS") != undefined ? grouped.get("SS").length :0
var SD = grouped.get("SD") != undefined ? grouped.get("SD").length :0
var TC = grouped.get("TC") != undefined ? grouped.get("TC").length :0
var LP = grouped.get("LP") != undefined ? grouped.get("LP").length :0
var DR = grouped.get("DR") != undefined ? grouped.get("DR").length :0
var MD = grouped.get("MD") != undefined ? grouped.get("MD").length :0
var GD = grouped.get("GD") != undefined ? grouped.get("GD").length :0
  this.labels_school = ["no_school", "elementary","secondary","state_diploma", "training","graduate","license", "doctorate","post_graduate"];
      this.datasets_school= [
        {
          backgroundColor: [
            'rgba(47, 66, 1, .8)',
            'rgba(228, 102, 81, .8)',
               'rgba(20, 56, 131, .8)',
            'rgba(252, 56, 81, .8)',
               'rgba(31, 31, 131, .8)',
            'rgba(255, 89, 81, .8)',
               'rgba(56, 18, 131, .8)',
            'rgba(28, 102, 81, .8)',
               'rgba(58, 184, 131, .8)'
          ],
          borderWidth: 0,
          data: [NS,ES,SS,SD,TC,LP,DR,MD,GD]
        }
      ];

},

GroupByRole () {

//const grouped = this.groupBy(pets, pet => pet.type);
const grouped = this.groupBy(this.members, member => member.role);
var MM = grouped.get("MM") != undefined ? grouped.get("MM").length :0
var CC = grouped.get("ES") != undefined ? grouped.get("CC").length :0
var YY = grouped.get("YY") != undefined ? grouped.get("YY").length :0
var MC = grouped.get("MC") != undefined ? grouped.get("MC").length :0
var SS = grouped.get("SS") != undefined ? grouped.get("SS").length :0
//console.log(grouped)
  this.labels_role = ["Members", "Choristes","Youth", "Masanga","Servants"];
      this.datasets_role= [
        {
         backgroundColor: [
          'rgba(65, 184, 131, .8)',
            'rgba(228, 102, 81, .8)',
            'rgba(0, 216, 255, .8)',
            'rgba(155, 89, 182, .8)',
             'rgba(100, 102, 81, .8)'],
          borderWidth: 0,
          data: [MM, CC, YY,MC,SS]
        }
      ];

},



GroupByChildren () {

//const grouped = this.groupBy(pets, pet => pet.type);
const grouped = this.groupBy(this.members, member => member.hasChildren);
var TTRUE = grouped.get(true) != undefined ? grouped.get(true).length :0
var FFALSE = grouped.get(false) != undefined ? grouped.get(false).length :0

  this.labels_child = ["Has Children", "without Children"];
      this.datasets_child= [
        {
          backgroundColor: [
            'rgba(0, 216, 255, .8)',
            'rgba(155, 89, 182, .8)'
          ],
          borderWidth: 0,
          data: [TTRUE, FFALSE]
        }
      ];

},

GroupBySmart () {

//const grouped = this.groupBy(pets, pet => pet.type);
const grouped = this.groupBy(this.members, member => member.hasSmartPhone);
var TTRUE = grouped.get(true) != undefined ? grouped.get(true).length :0
var FFALSE = grouped.get(false) != undefined ? grouped.get(false).length :0

  this.labels_smart = ["Has SmartPhone", "without SmartPhone"];
      this.datasets_smart= [
        {
          backgroundColor: [
            'rgba(0, 216, 255, .8)',
            'rgba(155, 89, 182, .8)'
          ],
          borderWidth: 0,
          data: [TTRUE, FFALSE]
        }
      ];

},


GroupBymaterialStatus () {

//const grouped = this.groupBy(pets, pet => pet.type);
const grouped = this.groupBy(this.members, member => member.maritalStatus);
//console.log(grouped.get("M").length)
var S = grouped.get("S") != undefined ? grouped.get("S").length :0
var M = grouped.get("M") != undefined ? grouped.get("M").length :0
var D = grouped.get("D") != undefined ? grouped.get("D").length :0
var V = grouped.get("V") != undefined ? grouped.get("V").length :0
  this.labels_Matrial = ["Single", "Married","Divorced","Veuf"];
      this.datasets_Matrial= [
        {
          backgroundColor: [
          'rgba(65, 184, 131, .8)',
            'rgba(228, 102, 81, .8)',
            'rgba(0, 216, 255, .8)',
            'rgba(155, 89, 182, .8)'
          ],
          borderWidth: 0,
          data: [S,M,D,V]
        }
      ];

},


    validate(){
      console.log("qr changed");
      this.valid = true;
    },
     b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
},
 makeid() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
},
Gender(){
    for(var i=0; i<this.members.length;i++)
    {
    console.log(i,this.members[i].gender)
    if(this.members[i].gender =='Femme' | this.members[i].gender =='femme' ) {
      this.update_census_gender(this.members[i].id,'F')
    } else if (this.members[i].gender =='Female' || this.members[i].gender =='female') {
    this.update_census_gender(this.members[i].id,'F')
    }
    else if (this.members[i].gender =='Homme' || this.members[i].gender =='homme') {
    this.update_census_gender(this.members[i].id,'M')
    }
    else if (this.members[i].gender =='Male' || this.members[i].gender =='male' ) {
    this.update_census_gender(this.members[i].id,'M')
    }
    }

},


Gender_u(){
    for(var i=0; i<this.users.length;i++)
    {
    console.log(i,this.users[i].gender)
    if(this.users[i].gender =='Femme' | this.users[i].gender =='femme' ) {
      this.update_census_gender(this.users[i].uuid,'F')
    } else if (this.users[i].gender =='Female' || this.users[i].gender =='female') {
    this.update_census_gender(this.users[i].uuid,'F')
    }
    else if (this.users[i].gender =='Homme' || this.users[i].gender =='homme') {
    this.update_census_gender(this.users[i].uuid,'M')
    }
    else if (this.users[i].gender =='Male' || this.users[i].gender =='male' ) {
    this.update_census_gender(this.users[i].uuid,'M')
    }
    }

},


Matrial(){
      for(var i=0; i<this.users.length;i++)
      {
      if(this.users[i].marital_status != undefined) {
      var valtoupdate = this.users[i].marital_status
      var id = this.users[i].uuid
      console.log(i,valtoupdate)

      if(valtoupdate =='Single' | valtoupdate =='single' ||  valtoupdate =='Célibataire'  ||  valtoupdate =='célibataire'  ) {
        this.update_census_gender(id,'S')
      } else if (this.members[i].maritalStatus =='Married' || valtoupdate =='married' ||  valtoupdate =='Marié(e)'
       || valtoupdate =='marié(e)' ||  valtoupdate =='marrié(e)' ) {
      this.update_census_gender(id,'M')
      }
      else if (this.members[i].maritalStatus =='Divorced' || valtoupdate =='divorced' 
      ||  valtoupdate =='Divorcé(e)' || valtoupdate =='divorcé(e)' ) {
      this.update_census_gender(id,'D')
      }
      else if (this.members[i].maritalStatus =='Veuf' || valtoupdate =='veuf' ||
       valtoupdate =='veuf (ve)' ) {
      this.update_census_gender(id,'V')
      }
      else if (valtoupdate =='Widower' || valtoupdate =='widower'  || valtoupdate =='widow' ) {
      this.update_census_gender(id,'V')
      }
      }
      }
},


Dime(){

            for(var i=0; i<this.users.length;i++)
      {
         if(this.users[i].marital_status != undefined) {
      var valtoupdate = this.users[i].marital_status
      var id = this.users[i].uuid
      console.log(i,valtoupdate)
      if(valtoupdate =='Par jour' || valtoupdate =='jour' 
      || valtoupdate =='par jour' || valtoupdate =='jours' ) {
        this.update_census_gender(id,'DD')
      } 
      else if (valtoupdate =='Par semaine' || valtoupdate =='semaine' 
      ||  valtoupdate =='par semaine' || valtoupdate =='semaines'  ) {
      this.update_census_gender(id,'WW')
      }
      else if (valtoupdate =='mois' || valtoupdate =='Par mois' || valtoupdate =='par mois'  || valtoupdate =='Mois' ) {
      this.update_census_gender(id,'MM')
      }
      else if (valtoupdate =='Par ans' || valtoupdate =='ans'  
      || valtoupdate =='par ans' || valtoupdate =='Ans' || valtoupdate =='années') {
      this.update_census_gender(id,'YY')
      }
      }
      }

},


MemberSince(){

            for(var i=0; i<this.members.length;i++)
      {
         if(this.members[i].memberSince != undefined) {
      var valtoupdate = this.members[i].memberSince
      var id = this.members[i].id
      console.log(i,valtoupdate)
     
        this.update_census_gender(id,new Date())
  
      }
      }
},


Role(){

            for(var i=0; i<this.users.length;i++)
      {
        if(this.users[i].role != undefined) {
          
      var valtoupdate = this.users[i].role
      var id = this.users[i].uuid
      console.log(i,valtoupdate)
      if(valtoupdate =='Fidèles' || valtoupdate =='fideles' 
      || valtoupdate =='Faithful'  ) {
        this.update_census_gender(id,'FF')
      } 
      else if (valtoupdate =='Serviteur de Dieu' || valtoupdate =='serviteurs' 
       ) {
      this.update_census_gender(id,'SS')
      }
      else if (valtoupdate =='Masanga (Comite de soutien)' || valtoupdate =='masanga (comité de soutien)' || valtoupdate=='masanga (support committee)' ) {
      this.update_census_gender(id,'MC')
      }
      else if (valtoupdate =='Choristes' || valtoupdate =='choristes'  
      || valtoupdate =='Choristers' ) {
      this.update_census_gender(id,'CC')
      }
            else if (valtoupdate =='youth' || valtoupdate =='Jeunesses'  
      || valtoupdate =='jeunesse') {
      this.update_census_gender(id,'YY')
      }
                  else if (valtoupdate =='members' || valtoupdate =='membres'  
      ) {
      this.update_census_gender(id,'MM')
      }
      }
      }

},
Type_s(){

            for(var i=0; i<this.users.length;i++)
      {
        console.log('here')
         if(this.users[i].type != undefined) {
      var valtoupdate = this.users[i].type
      console.log(i,valtoupdate)
      if(valtoupdate =='member' || valtoupdate =='Member' 
       ) {
        this.update_census_gender(this.users[i].uuid,'M')
      } 
      else if (valtoupdate =='employee' || valtoupdate =='Employee' 
        ) {
      this.update_census_gender(this.users[i].uuid,'E')
      }
      else if (valtoupdate =='admin' || valtoupdate =='Admin'  ) {
      this.update_census_gender(this.users[i].uuid,'A')
      }
      else if (valtoupdate =='merchant' || valtoupdate =='Merchant'  
     ) {
      this.update_census_gender(this.users[i].uuid,'C')
      }
      else if (valtoupdate =='serviteur' || valtoupdate =='Serviteur'
      || valtoupdate =='Servant'  
     ) {
      this.update_census_gender(this.users[i].uuid,'S')
      }
      }
      }

},



School(){
      for(var i=0; i<this.members.length;i++)
      {
      if(this.members[i].niveauScolaire != undefined) {
      var valtoupdate = this.members[i].niveauScolaire
      var id = this.members[i].id
      console.log(i,valtoupdate)

      if(valtoupdate =='Enseignement Supérieur' || valtoupdate =='higher education' || valtoupdate=='enseignement superieur'  ) {
        this.update_census_gender(id,'GD')
      } else if (valtoupdate =='École Secondaire'  || valtoupdate == 'secondary school' ||  valtoupdate == 'école secondaire' || 
      valtoupdate =='Secondaire' || valtoupdate =='Secondary school' || valtoupdate =='V') {
      this.update_census_gender(id,'SS')
      }
      else if (valtoupdate == 'École Primaire'
       || valtoupdate == 'école primaire' ||valtoupdate =='ecole primaire' || valtoupdate =='elementary school') {
      this.update_census_gender(id,'ES')
      }
      else if (valtoupdate =='École Technique' || valtoupdate =='technical school' || valtoupdate=='Technical School' ||valtoupdate =='brevet de formation' || valtoupdate =='Diplôme Professionnel' || valtoupdate =='D'  ) {
      this.update_census_gender(id,'TC')
      }
         else if (valtoupdate =='licensed professional' || valtoupdate=='licence'  ) {
      this.update_census_gender(id,'LP')
      }
              else if (valtoupdate =='no school'  ) {
      this.update_census_gender(id,'NS')
      }
                    else if (valtoupdate =='diplôme détat' || valtoupdate =='state issued diploma'  ) {
      this.update_census_gender(id,'SD')
      }
                    else if (valtoupdate =='graduat' || valtoupdate == 'graduate'  ) {
      this.update_census_gender(id,'GD')
      }
                    else if (valtoupdate =='post-graduate specialization'  ||valtoupdate =='Specialisation post universitaire' ) {
      this.update_census_gender(id,'MD')
      }


      }
      }
},

    update_census_gender (id,type) {
     // await this.sleep(10);
      db.collection("Census")
        .doc(id)
        .update({
          "memberSince": type
        })
        .then(() => {
        console.log(id)
        })
        .catch(error => {
          console.error("Error update member: ", error);
        });
  },

create_qr_code : async function() {
     var qrcode = []; 
     var url = '';
     var id1 ='';
     var id2= '';
     var members = this.$store.getters.valideUsers
     var counter = members.length;
    var i ;
     var that = this
     console.log(counter)
     var busy = false
     var uploadTask
    for(i=0; i<3;i++) {
      while(busy == true);
      busy = true;
  
                id1 = members[i].id;
                this.message = ""+id1
                console.log('id first',id1,this.message)
                console.log('title 1',document.getElementById('qr_code').title)
                var x = 0;
                await this.sleep(0);
                /*
                while(document.getElementById('qr_code').title != this.message)
                {
                  x++;
                  if (x > 50000000)
                  break;
                }*/
                console.log('title 2',document.getElementById('qr_code').title)
              
                var someimage = document.getElementById('qr_code');
                var myimg = someimage.getElementsByTagName('img')[0];              
                var mysrc = myimg.src;
                var block = mysrc.split(";");
                var contentType = block[0].split(":")[1];// In this case "image/gif"
                var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
                var blob= this.b64toBlob(realData, contentType)
                uploadTask = storage.ref().child(`serviteurs/${id1}/qr_code/file_${id1}`).put(blob);
                
                var progress =0;
        // Listen for state changes, errors, and completion of the upload.
              uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
             function(snapshot) {
        
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
             progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          
                //console.log('id first 2 ',id1)
            //console.log('Upload is ' + progress +'val'+ '% done');
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                //console.log('Upload paused');
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                //console.log('Upload running');
              
                break;
            }
          }, function(error) {
            console.log('Upload error');
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        }, function() {
          console.log('id second', id1) 
            
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              console.log('File available at bar code', downloadURL);
          //  console.log('id se', id)
           that.update_census(id1,downloadURL)
                    downloadURL=''
                    blob=''    
          }); 
      
}); 
      
      busy = false;
      
      await this.sleep(1000);
    }
    //console.log(JSON.stringify(qrcode))
  
    },
           sleep2(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds){
      break;
    }
  }
},
        sleep(ms) {

        return new Promise(resolve => setTimeout(resolve, ms));
      },

  update_census (id,url) {
     // await this.sleep(10);
      db.collection("Census")
        .doc(id)
        .update({
            qr_url:url
        })
        .then(() => {
        console.log(id)
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
  },


    testConvert() {
      db
      .collection('Census').doc("zTjZudO2FbDc8O4U4Ct7")
      .get()
      .then(doc => {
        var id = doc.id
           var hasChildren = doc.data().hasChildren
           var hasSmartPhone = doc.data().hasSmartPhone
           var isBuyPhoneReady = doc.data().isBuyPhoneReady
           var isWithChildren = doc.data().isWithChildren
           var data = {
             id: id,
             hasChildren: false,
             hasSmartPhone: false,
             isBuyPhoneReady: false,
             isWithChildren: false
           }
            
           if (hasChildren == "Oui") {
              data.hasChildren = true
          }

          if (hasSmartPhone == "Oui") {
              data.hasSmartPhone = true
          }

          if (isBuyPhoneReady == "Oui") {
              data.isBuyPhoneReady = true
          }

          if (isWithChildren == "Oui") {
              data.isWithChildren = true
          }
          this.converts.push(data)
          this.updateData()
      })
    },
    toLowerCase() {
      db
      .collection('Census')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
           
           var id = doc.id
           var hasChildren = doc.data().hasChildren
           var hasSmartPhone = doc.data().hasSmartPhone
           var isBuyPhoneReady = doc.data().isBuyPhoneReady
           isWithChildren = doc.data().isWithChildren
           var data = {
             id: id,
             hasChildren: false,
             hasSmartPhone: false,
             isBuyPhoneReady: false,
             isWithChildren: false
           }
            
          if (hasChildren == "Oui") {
              data.hasChildren = true
          }

          if (hasSmartPhone == "Oui") {
              data.hasSmartPhone = true
          }

          if (isBuyPhoneReady == "Oui") {
              data.isBuyPhoneReady = true
          }

          if (isWithChildren == "Oui") {
              data.isWithChildren = true
          }

          this.converts.push(data)
          })
          this.updateData()
        })
    },
    updateData () {
      var lowerRef = db.collection('Census')
      this.converts.forEach((convert, index) => {
      console.log(convert.lowerAccess)
       lowerRef.doc(convert.id)
            .update({
              hasChildren: convert.hasChildren,
              hasSmartPhone: convert.hasSmartPhone,
              isBuyPhoneReady: convert.isBuyPhoneReady,
              isWithChildren: convert.isWithChildren
            })
      })
    },
    allMembers () {
      this.$router.push('/widgets/allmembers')
    },
    todayMembers () {
      this.$router.push('/widgets/todayList')
    },
    showServiteurs () {
      this.$router.push('/widgets/serviteurs')
    },
    showEmployees () {
      this.$router.push('/employees')
    },
        showMassaga () {
      this.$router.push('/widgets/massaga')
    },
    getMonthlyData () {

    }
  }
}
</script>

<style>


#divchart{
    color: #fff;
    font-family: Tahoma, Verdana, Segoe, sans-serif;
    padding: 10px;
}
.container{
   
    display:flex;
}
.fixed{
  
    width: 200px;
}
.flex-item{

    flex-grow: 1;
}

body {
  animation: colorchange 50s infinite;
}

@keyframes colorchange
{
  0%   {background: #9b59b6;}
  25%  {background: #f1c40f;}
  50%  {background: #3498db;}
  75%  {background: #1abc9c;}
  100% {background: #9b59b6;}
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.container {
  max-width: 800px;
  margin:  0 auto;

  color:  rgba(155, 89, 182, 1);
}


.Chart {
   margin:  25px 0;
  /*border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  margin:  25px 0;*/
}

.Chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color:  rgba(255, 0,0, 0.5);
  border-bottom: 1px solid #323d54;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue